import { Avatar, Clickable, Col, Row, Text } from 'components';
import { closeNotifs, theme } from 'lib';
import { Trans, useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';

const Image = styled.img`
  margin-left: 16px;
  width: 48px;
  height: 48px;
`;

const PostTagged = ({ data }) => {
  const { sender, type, timestamp, entityId } = data,
    dispatch = useDispatch(),
    navigate = useNavigate(),
    { t } = useTranslation();

  function handleClick() {
    closeNotifs(dispatch);
    navigate(`/post/${entityId}`);
  }

  return (
    <Clickable onClick={handleClick}>
      <Row noFlex pad="0 0 16px" center>
        <Avatar small avatar={sender.avatar} user={sender} />

        <Col marg="0 0 0 16px">
          <Row between useStart>
            <Trans
              parent={Text}
              components={{
                strong: <Text bold />
              }}
            >
              {t('notifications.taggedInPost', { sender: sender.name || sender.username })}
            </Trans>

            <Text b2 med col={theme.GREY_60}>
              {timestamp}
            </Text>
          </Row>
        </Col>
      </Row>
    </Clickable>
  );
};

export default PostTagged;
